import Widget from '@/plugins/dashboard/widgets/PickupsTable/Widget'
import Configure from '@/plugins/dashboard/widgets/PickupsTable/Configure'
import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'

export default class extends BaseWidget {
  static name = 'Pickups Table'
  static widget = Widget
  static configure = Configure
}
